import * as React from 'react'
import { Route, Switch } from 'react-router'

import { Redirect404 } from '../common/ui'

import { PublicPage as HomePage } from '../home/PublicPage'

import { PublicPage as NotFoundPage } from './../not-found/PublicPage'

import { config as notFoundConfig } from '../not-found'

import FormRecordPublicPage from '../form-record-pages/public-view/Page'

export const Routes = () => {
  return (
    <Switch>
      <Route exact={true} path="/" component={HomePage} />

      <Route
        exact={true}
        path={'/form/:formRecordId'}
        component={FormRecordPublicPage}
      />

      <Route
        exact={true}
        path={notFoundConfig.ui.urls.notFound()}
        component={NotFoundPage}
      />

      <Redirect404 />
    </Switch>
  )
}
